module.exports = __webpack_public_path__ + "static/media/delete-disabled.16fa312b.svg";